module.exports = __webpack_public_path__ + "static/media/logo.e15e92db.png";